const Cart = function ({ emailAddress = '', eventId = null, ticketId = null }) {
    if (!(emailAddress && eventId && ticketId)) {
        throw new Error('Invalid Cart')
    }
    this.emailAddress = emailAddress
    this.eventId = eventId
    this.ticketId = ticketId
}

export default Cart
